import { render } from "./EditManifesto.vue?vue&type=template&id=4f49da59"
import script from "./EditManifesto.vue?vue&type=script&lang=js"
export * from "./EditManifesto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__